














import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import Default from '../components/common/Default.vue'
import { ActionSignUp } from '../store/user/types'
import { Page, ErrorMessage } from '../type'
import LoadingModal from '../components/common/LoadingModal.vue'

const UserModule = namespace('user')

@Component({ components: { Default, LoadingModal } })
export default class Signup extends Vue {
  @UserModule.Action('signup') signup!: ActionSignUp
  loading = false
  error = ''

  handleSignup() {
    this.loading = true
    this.signup()
      .then(() => {
        this.$router.push({ name: Page.Mypage })
      })
      .catch((e: Error) => {
        if (e.message === ErrorMessage.UserAlreadyExsists) {
          this.error = 'このアカウントは登録済です'
        }
      })
      .finally(() => {
        this.loading = false
      })
  }
}
